<script>
export default {
  name: "DidoApidocUsageSorting",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    Les données renvoyées par l'api peuvent être triées par l'intermédiaire du
    paramètre
    <span class="bg-black text-white q-pa-xs">orderBy</span> de la requête.
    <br /><br />
    Le paramètre
    <span class="bg-black text-white q-pa-xs">orderBy</span> doit être construit
    de la manière suivante :
    <span class="bg-black text-white q-pa-xs"
      >orderBy=[-]colonneTri1,[-]colonneTri2</span
    >.
    <br />
    <br />
    Les colonnes disponibles pour le tri:
    <ul>
      <li>
        Pour la liste des jeux de données ou des fichiers de données :
        <br />
        les colonnes disponibles sont
        <span class="underline-dotted">title</span> et
        <span class="underline-dotted">last_modified</span>.
        <br />
        exemple pour renvoyer tous les jeux de données triés par date de
        modification la plus récente puis par ordre alphabétique croissant :
        <br />
        <span class="bg-black text-white q-pa-xs"
          >$BASE_URL_API/datasets?page=1&pageSize=all&orderBy=-last_modified,title</span
        >.
      </li>
      <li>
        Pour les données d'un millésime (pagination et exports dans différents
        formats) :
        <br />
        Toutes les colonnes disponibles dans le millésime peuvent être utilisées
        pour trier.
        <br />
        La liste des colonnes disponibles pour un millésime est disponible dans
        le champ
        <span class="underline-dotted">columns</span> de l'objet renvoyé par la
        requête suivante :
        <br />
        <span class="bg-black text-white q-pa-xs"
          >$BASE_URL_API/datafiles/{datafileRid}?millesime={millesimeValue}</span
        >.
      </li>
      <li>
        Pour les données d'un référentiel (pagination et exports dans différents
        formats) :
        <br />
        Toutes les colonnes disponibles dans le référentiel peuvent être
        utilisées pour trier.
        <br />
        La liste des colonnes disponibles pour un référentiel est disponible
        dans l'apidoc dédié au référentiel.
        <br />
        Par exemple pour
        <span class="underline-dotted">le référentiel cog</span>, vous pourrez
        trouver la liste des colonnes disponibles dans
        <a
          href="#get-/v1/referentiels/cog"
          title="Voir les paramètres de requêtage du cog"
          >les paramètres de requêtage du cog</a
        >.
      </li>
      <li>
        Pour les données d'une nomenclature (pagination et exports dans
        différents formats) :
        <br />
        Toutes les colonnes disponibles dans la nomenclature peuvent être
        utilisées pour trier.
        <br />
        La liste des colonnes disponibles pour une nomenclature est disponible
        dans l'apidoc dédié à la nomenclature.
        <br />
        Par exemple pour
        <span class="underline-dotted">la nomenclature bilan de l'énergie</span
        >, vous pourrez trouver la liste des colonnes disponibles dans
        <a
          href="#get-/v1/nomenclatures/bilanEnergie"
          title="Voir les paramètres de requêtage de la nomenclature du bilan de l'énergie"
          >les paramètres de requêtage de la nomenclature du bilan de
          l'énergie</a
        >.
      </li>
    </ul>
  </div>
</template>
